import { Api } from "../api";
import { AxiosResponse } from "axios";

const municipalityApi = (municipalityId) =>
  new Api(`api/Municipalities/${municipalityId}/reports`);

/**
 * @param {number} municipalityId
 * @param {number} year
 * @returns {Promise<AxiosResponse<File>>}
 */
export const getAnnualReportFinancials = (municipalityId, year) =>
  municipalityApi(municipalityId).getFile(`financials/${year}`);

/**
 * @param {number} municipalityId
 * @param {object} payload
 * @returns {Promise<AxiosResponse<File>>}
 */
export const getSummaryQuestionnaires = (municipalityId, payload) =>
  municipalityApi(municipalityId).getFile("summary/questionnaires", payload);

/**
 * @param {number} municipalityId
 * @param {object} payload
 * @returns {Promise<AxiosResponse<File>>}
 */
export const getSummaryFinancials = (municipalityId, payload) =>
  municipalityApi(municipalityId).getFile("summary/financials", payload);

/**
 * @param {number} municipalityId
 * @param {object} payload
 * @returns {Promise<AxiosResponse<File>>}
 */
export const getSummaryProjectResults = (municipalityId, payload) =>
  municipalityApi(municipalityId).getFile("summary/project/results", payload);

/**
 * @param {number} municipalityId
 * @param {object} payload
 * @returns {Promise<AxiosResponse<File>>}
 */
export const getSummaryProjects = (municipalityId, payload) =>
  municipalityApi(municipalityId).getFile("summary/projects", payload);
